module.exports = __webpack_public_path__ + "static/media/05.03.8e1a9f25.webp";